// Components
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Section from "../components/Section";

// Page Components
import Hero from "./Home/Hero";
import Benefits from "./Home/Benefits";
import ArtClasses from "./Home/ArtClasses";
import ArtExhibition from "./Home/ArtExhibition";




const Home = () => {
  
  return (

    <>

      <Navbar/>

        
      {/* HERO */}
      <Section minMargin="my-0">
        <Hero />
      </Section>
      
      {/* BENEFITS */}
      <Section minPadding="py-4" minMargin="my-0" section_color='main'>
        <Benefits />
      </Section>
      
      {/* ART CLASSES */}
      <Section>
        <ArtClasses page_color='main' />
      </Section>
      
      {/* EXHIBITION */}
      <Section minPadding="py-4" minMargin="m-0" maxMargin="m-0" section_color='main'>
        <ArtExhibition />
      </Section>


      <Footer/>

    </>

  );
}

export default Home;